import React from 'react'
import Layout from 'App/Pages/Auth/Layout'
import Authorize from './Authorize'
import VerifyLogin from './VerifyLogin'
import {withRouter} from 'react-router'

@withRouter
export default class UnauthorizedSession extends React.Component {
  static propTypes = {}

  renderChild() {
    const pathname = this.props.router.location.pathname
      
    if(pathname.includes('/verify-login/')) return <VerifyLogin />
    
    return <Authorize />
  }

  render() {
    return (
      <Layout>
        { this.renderChild() }
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Root/ApolloError/UnauthorizedSession/index.js